import { IListItem, IContact, IRecipientProfileHlaValues } from '@nkr/models/index';

export interface IRecipientSearchReportLookupData {
    centerList: IListItem[],
    clusterList: IListItem[],
    positionList: IListItem[],
    chainList: IListItem[],
    swapList: IListItem[],
    logisticsList: IListItem[],
    desensitizationList: IListItem[],
    donorRelationList: IListItem[],
    transportMethodList: IListItem[],
    voucherStatusList: IListItem[],
    stateList: IListItem[],
    coordinatorList: IContact[],
    matchStatusList: IListItem[],
    patientTypeList: IListItem[],
    recipientReportLogActionList: IListItem[],
    recipientInactiveReasonList: IListItem[],
    compatiblePairKpdReasonList: IListItem[],
    deleteReasonList: IListItem[],
    insuranceGroupList: IListItem[],
    hlaValueList: IRecipientProfileHlaValues[],
    raceList: IListItem[],
    antiATiterValueList: IListItem[],
    acuteAMRGradeList: IListItem[],
    acuteTCMRGradeList: IListItem[],
    biopsyReasonList: IListItem[],
    iftaGradeList: IListItem[],
    rejectionDSATypeList: IListItem[],
    rejectionTreatmentTypeList: IListItem[],
    graftFailureReasonList: IListItem[]
    contactList: IContact[]
}